<template>
  <AffiliateSalesReport />
</template>

<script>
import AffiliateSalesReport from '@/components/AffiliateSalesReport.vue';

// @ is an alias to /src


export default {
name: "SendPushs",
components: {
  AffiliateSalesReport,
},
};
</script>
